import React, { useState, useEffect } from 'react';
import styled, { createGlobalStyle } from 'styled-components';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faLinkedin, faTwitter } from '@fortawesome/free-brands-svg-icons';
import achievementData from './achievements';
import './App.css';

//a

const GlobalStyle = createGlobalStyle`
  body {
    background-color: #262626;
    color: white;
    margin: 0;
    padding: 0;
    font-family: Arial, sans-serif;
  }
`;

const Header = styled.header`
  background-color: #262626;
  color: white;
  text-align: center;
  padding: 2rem 0;
`;

const Navbar = styled.nav`
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #262626;
  position: sticky;
  top: 0;
  z-index: 100;
`;

const NavItem = styled.a`
  color: white; 
  text-decoration: none;
  font-size: 1.15rem;
  margin: 0 1rem;
  padding: 0.5rem 1rem;
  border-radius: 5px;
  transition: background-color 0.3s ease-in-out;

  &:hover {
    background-color: black; 
    cursor: pointer;
  }
`;

const Container = styled.div`
  max-width: 800px;
  margin: 0 auto;
  padding: 2rem;
  background-color: #1a1a1a;
  box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.1);
`;

const Achievement = styled.div`
  margin-bottom: 2rem;
  padding: 1.5rem;
  border: 1px solid #333;
  border-radius: 10px;
  background-color: #333;
  box-shadow: 0px 4px 6px rgba(0, 0, 0, 0.1);
`;

const Title = styled.h2`
  font-size: 1.5rem;
  margin-bottom: 1rem;
  color: lightgreen;
`;

const Description = styled.p`
  font-size: 1rem;
  color: #ccc;
`;

const Screenshot = styled.img`
  max-width: 100%;
  border-radius: 5px;
`;

const Footer = styled.footer`
  background-color: #111;
  color: white;
  text-align: center;
  padding: 2rem 0;
`;

const SocialLinks = styled.div`
  margin-top: 1rem;
  display: flex;
  justify-content: center;
  align-items: center;

  a {
    margin: 0 0.5rem;
    color: #fff;
    font-size: 1.5rem;
    text-decoration: none;
    transition: color 0.3s ease-in-out;

    &:hover {
      color: lightgreen;
    }
  }
`;

const OBBLink = styled.a`
  color: lightgreen;
  text-decoration: none;
  font-size: 1.15rem;
  margin: 0.5rem;
`;

const ScrollButton = styled.button`
  background-color: transparent;
  color: #fff;
  border: none;
  cursor: pointer;
  font-size: 1.2rem;
  transition: color 0.3s ease-in-out;

  &:hover {
    color: lightgreen;
  }
`;

function App() {
  const [animatedText, setAnimatedText] = useState('');

  const originalText = "Helped secured total of 65+ websites";

  useEffect(() => {
    let currentIndex = 0;
    const intervalId = setInterval(() => {
      if (currentIndex <= originalText.length) {
        setAnimatedText(originalText.slice(0, currentIndex));
        currentIndex++;
      } else {
        clearInterval(intervalId);
      }
    }, 100);

    return () => {
      clearInterval(intervalId);
    };
  }, []);

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth"
    });
  };

  const scrollToAchievements = () => {
    const achievementsSection = document.getElementById("achievements");
    if (achievementsSection) {
      achievementsSection.scrollIntoView({ behavior: "smooth" });
    }
  };

  const scrollToContact = () => {
    const contactSection = document.getElementById("footer");
    if (contactSection) {
      contactSection.scrollIntoView({ behavior: "smooth" });
    }
  };

  const scrollToLinks = () => {
    const contactSection = document.getElementById("footer");
    if (contactSection) {
      contactSection.scrollIntoView({ behavior: "smooth" });
    }
  };

  return (
    <div className="App">
      <GlobalStyle />
      <Header>
        <Navbar>
          <NavItem onClick={scrollToTop}>Home</NavItem>
          <NavItem onClick={scrollToAchievements}>Achievements</NavItem>
          <NavItem onClick={scrollToContact}>Contact</NavItem>
          <NavItem onClick={scrollToLinks}>Links</NavItem>
        </Navbar>
        <h1>ANIKET SHRUNGARE 🙋🏻‍♂️ Bug Hunting Achievements</h1>
        <h3 className="typewriter">{animatedText}</h3>
      </Header>
      <Container id="achievements">
        {achievementData.map((achievement, index) => (
          <Achievement key={index}>
            <Title>{achievement.title}</Title>
            <Description>{achievement.description}</Description>
            <Screenshot src={achievement.screenshot} alt={`Screenshot ${index + 1}`} />
          </Achievement>
        ))}
      </Container>
      <h3>Checkout more on:
        <OBBLink href="https://www.openbugbounty.org/researchers/anikett/" target="_blank" rel="noopener noreferrer">
          OpenBugBounty
        </OBBLink>
        <OBBLink href="https://bugcrowd.com/aniket22" target="_blank" rel="noopener noreferrer">
          BugCrowd
        </OBBLink></h3>
      <Footer id="footer">
        <SocialLinks>
        <p>Connect with me on </p>
          <a href="https://www.linkedin.com/" target="_blank" rel="noopener noreferrer">
            <FontAwesomeIcon icon={faLinkedin} />
          </a>
          {/* <a href="https://www.twitter.com/" target="_blank" rel="noopener noreferrer">
            <FontAwesomeIcon icon={faTwitter} />
          </a> */}
          {/* Add more social links as needed */}
        </SocialLinks>
      </Footer>
    </div>
  );
}

export default App;
